<template>
  <nav class="bg-gray-900">
    <div class="flex flex-wrap items-center justify-between p-1 mx-10">
      <a href="#" class="flex items-center space-x-3 rtl:space-x-reverse">
        <img src="../../assets/logo.png" class="h-14" alt="FreeTalk Logo" />

        <span
          class="self-center text-2xl font-semibold text-white whitespace-nowrap"
          >FreeTalk</span
        >
      </a>
      <div class="flex space-x-3 md:order-2 md:space-x-0 rtl:space-x-reverse">
        <button
          @click="$router.push('signup')"
          class="px-10 py-3 font-medium text-center text-white rounded-lg bg-primary focus:ring-4 focus:outline-none text-md"
        >
          <router-link to="/signup">Rejoindre la communauté</router-link>
        </button>
        <button
          data-collapse-toggle="navbar-cta"
          type="button"
          class="inline-flex items-center justify-center w-10 h-10 p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-600"
          aria-controls="navbar-cta"
          aria-expanded="false"
        >
          <span class="sr-only">Open main menu</span>
          <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
      </div>
      <div
        class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
        id="navbar-cta"
      >
        <ul
          class="flex flex-col p-4 mt-4 font-medium bg-gray-800 border border-gray-700 rounded-lg md:p-0 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-gray-900"
        >
          <li>
            <a
              @click="$emit('scrollTo', 'home')"
              class="block px-3 py-2 rounded cursor-pointer text-white-900 md:border-0 md:p-0"
              aria-current="page"
            >
              Accueil
            </a>
          </li>
          <li>
            <a
              @click="$emit('scrollTo', 'posts')"
              class="block px-3 py-2 rounded cursor-pointer text-white-900 md:border-0 md:p-0"
            >
              Posts
            </a>
          </li>
          <li>
            <a
              @click="$emit('scrollTo', 'about')"
              class="block px-3 py-2 rounded cursor-pointer text-white-900 md:border-0 md:p-0"
            >
              A Propos
            </a>
          </li>
          <li>
            <a
              @click="$emit('scrollTo', 'feedback')"
              class="block px-3 py-2 rounded cursor-pointer text-white-900 md:border-0 md:p-0"
            >
              FeedBack
            </a>
          </li>
          <li>
            <a
              @click="$emit('scrollTo', 'teams')"
              class="block px-3 py-2 rounded cursor-pointer text-white-900 md:border-0 md:p-0"
            >
              Teams
            </a>
          </li>
          <li>
            <a
              @click="$emit('scrollTo', 'contact')"
              class="block px-3 py-2 rounded cursor-pointer text-white-900 md:border-0 md:p-0"
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
</template>

<script>
// @ is an alias to /src
export default {
  name: "NavBar",
};
</script>
